import { Routes } from '@/core/router/routes.types';
import React from 'react';
import { useSelector } from 'react-redux';
import { generatePath, useHistory, useParams } from 'react-router';
import RouterNavigationTabs from '@/components/organisms/RouterNavigationTabs';
import { getErrorCode } from '@/utils/errors';
import {
    useGetGuestGroupMapByDepthQuery,
    usePostGuestGroupMutation,
} from '@/services/innovorder/guestGroup/guestGroup.endpoints';
import { useGetMinimalPricingRulesQuery } from '@/services/innovorder/pricingRule/pricingRule.endpoints';
import { getUserToken } from '@/redux/user';
import { routes } from '@/core/router/routes';
import GroupForm from '../GroupForm';
import { GuestGroupsByDepthKey } from '../Groups/types';

type CreateGroupProps = {
    depth: GuestGroupsByDepthKey;
};

type ParamTypes = {
    brandId: string;
};

const CreateGroup: React.FunctionComponent<React.PropsWithChildren<CreateGroupProps>> = ({ depth }) => {
    const history = useHistory();
    const { brandId } = useParams<ParamTypes>();
    const token = useSelector(getUserToken);
    const { data: pricingRulesData } = useGetMinimalPricingRulesQuery({
        brandId: parseInt(brandId, 10),
        token,
    });
    const { data: guestGroupMapByDepth } = useGetGuestGroupMapByDepthQuery({
        brandId: parseInt(brandId, 10),
        token,
    });

    const [postGroup, { isSuccess, error, data, isLoading }] = usePostGuestGroupMutation();
    if (isSuccess && data?.name) {
        history.push(generatePath(Routes.Groups, { brandId }));
    }

    const post = (name: string, pricingRules: number[], parentGuestGroupId?: number | null, depth?: number) => {
        postGroup({
            brandId: parseInt(brandId, 10),
            name,
            pricingRules,
            parentGuestGroupId,
            depth,
            token,
        });
    };

    const tabRoutes = React.useMemo(() => routes.filter(({ tab }) => tab === 'brands'), []);

    return (
        <RouterNavigationTabs routes={tabRoutes}>
            <GroupForm
                depth={depth}
                error={getErrorCode(error)}
                onSubmit={post}
                isLoading={isLoading}
                pricingRules={pricingRulesData || []}
                guestGroupMap={guestGroupMapByDepth || {}}
            />
        </RouterNavigationTabs>
    );
};

export default CreateGroup;
